export default function isInAppContentTemplate(props: any) {
  return props!!.actions[0]?.actionBody?.contentIds ? true : false;
}